export const root = "rqh4kqw";
export const childWrapper = "c1pdu1w9";
export const error = "e1kxqasm";
export const errorList = "e1unbarj";
export const hasIcon = "hckoznd";
export const icon = "i151mvbo";
export const noBorder = "n1m8jjkv";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");